import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Loader2, Users, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/customers").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const toggle = (c) => api.put(`/admin/customers/${c.id}/toggle`).then(() => { toast.success("Updated"); load(); });
  const del = (c) => { if (!window.confirm(`Delete customer ${c.name || c.email}? This cannot be undone.`)) return; api.delete(`/admin/customers/${c.id}`).then(() => { toast.success("Customer deleted"); load(); }).catch((e) => toast.error(e.response?.data?.detail || "Delete failed")); };

  return (
    <div>
      <h1 className="font-heading text-3xl lg:text-4xl text-forest tracking-tight mb-6">Customers</h1>
      <div className="bg-white rounded-2xl soft-shadow overflow-hidden">
        {!list ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-forest" /></div> :
          list.length === 0 ? <p className="text-center py-16 text-muted-foreground"><Users className="w-10 h-10 mx-auto mb-2 text-sage" />No customers yet.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-sand text-brown"><tr>{["Name", "Email", "Phone", "Orders", "Joined", "Active", ""].map((h) => <th key={h} className="text-left px-4 py-3 font-500 whitespace-nowrap">{h}</th>)}</tr></thead>
              <tbody>
                {list.map((c) => (
                  <tr key={c.id} className="border-t border-sage/15" data-testid={`customer-${c.id}`}>
                    <td className="px-4 py-3 font-500 text-ink">{c.name}</td>
                    <td className="px-4 py-3 text-brown">{c.email}</td>
                    <td className="px-4 py-3 text-brown">{c.phone || "—"}</td>
                    <td className="px-4 py-3 text-forest font-500">{c.orders}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{c.created_at?.slice(0, 10)}</td>
                    <td className="px-4 py-3"><Switch checked={c.active} onCheckedChange={() => toggle(c)} data-testid={`customer-toggle-${c.id}`} /></td>
                    <td className="px-4 py-3"><button onClick={() => del(c)} data-testid={`customer-delete-${c.id}`} className="p-1.5 hover:bg-sand rounded-lg" title="Delete customer"><Trash2 className="w-4 h-4 text-terracotta" /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
